import "./_step-slider-styles.scss";

import './step-slider';
